const config = {
  env: import.meta.env.VITE_APP_ENV,
  cloudinary: {
    apiKey: import.meta.env.VITE_CLOUDINARY_API_KEY,
    cloudName: import.meta.env.VITE_CLOUDINARY_CLOUD_NAME,
    uploadPreset: import.meta.env.VITE_CLOUDINARY_UPLOAD_PRESET,
    showPoweredBy: false,
    cropping: true,
    croppingAspectRatio: 0.8,
    showSkipCropButton: false,
    sources: ["local", "camera"],
    multiple: false,
    folder: `sababuu_${import.meta.env.VITE_APP_ENV}`,
    uploadUrl:
      "https://api.cloudinary.com/v1_1/" +
      import.meta.env.VITE_CLOUDINARY_CLOUD_NAME +
      "/image/upload",
    clientAllowedFormats: ["jpg", "jpeg", "png"],
    styles: {
      palette: {
        window: "#FFF",
        sourceBg: "#FFFFFF",
        link: "#e94057",
        action: "#e94057",
      },
      frame: {
        background: "#FFFFFF",
      },
      fonts: ['"Montserrat", sans-serif'],
    },
    text: {
      en: {
        menu: {
          files: "My Device",
        },
      },
    },
  },
  posthog: {
    key: import.meta.env.VITE_POSTHOG_API_KEY,
    churnSurveyId: import.meta.env.VITE_POSTHOG_CHURN_SURVEY_ID,
    interviewSurveyId: import.meta.env.VITE_POSTHOG_INTERVIEW_SURVEY_ID,
    apiHost: import.meta.env.VITE_POSTHOG_API_HOST,
  },
};

export default config;
